import { useQueryClient } from '@tanstack/react-query';
import { Modal } from 'antd';
import { useAccorderen } from 'components/headers/menu/model/accorderen';
import { Spinal } from 'components/spinal/Spinal';
import { refreshCallContext } from 'helpers/queries/call-context';
import { useState } from 'react';

export const useIndienenModal = () => {
  const [visible, setVisible] = useState(false);
  const queryClient = useQueryClient();
  const indienen = useAccorderen();
  const component = (
    <Modal
      title="Bevestigen"
      open={visible}
      onOk={e =>
        indienen.mutate(null, {
          onSuccess() {
            setVisible(false);
            void refreshCallContext(queryClient);
            e.stopPropagation();
          },
          onError() {
            setVisible(false);
            e.stopPropagation();
          },
        })
      }
      onCancel={e => {
        setVisible(false);
        e.stopPropagation();
      }}
      okText="Ja"
      cancelText="Nee"
      okButtonProps={{
        style: { backgroundColor: '#00A1DF', borderColor: '#00A1DF' },
        disabled: indienen.isPending,
      }}
      cancelButtonProps={{
        style: { backgroundColor: '#6e7881', borderColor: '#6e7881', color: '#fff' },
        disabled: indienen.isPending,
      }}
      width={750}
      maskClosable={!indienen.isPending}
      closable={!indienen.isPending}>
      <Spinal loading={indienen.isPending} initializing={false}>
        <ul style={{ textAlign: 'left', marginBottom: '15px' }}>
          <li style={{ marginBottom: '10px' }}>U heeft gecontroleerd dat uw vervoer dierlijke mest gegevens (op basis van VDM) compleet zijn.</li>
          <li style={{ marginBottom: '10px' }}>
            U heeft gecontroleerd dat bij al uw automatische voerleveranties de CO2-emmisiewaarden opgesplitst zijn in CO2-Biogeen, CO2-Fossiel excl. veen,
            CO2-LandUseChange (LUC) en CO2-Veen. Als niet bij alle leveringen de CO2-emmisie opgesplitst is, worden voor CO2 berekeningen standaardwaarden
            gebruikt. Als u specifieke uitgesplitste CO2-waarden wilt gebruiken, moeten deze voor alle voerleveringen aangeleverd zijn. Als dit niet (voor alle
            leveringen) het geval is, neem dan contact op met uw voerleverancier.
          </li>
          <li style={{ marginBottom: '10px' }}>
            U heeft gecontroleerd dat geleverde en gebruikte mest- en voeradditieven automatisch zijn aangeleverd door uw leverancier. Zo niet, neem contact op
            met uw leverancier.
          </li>
        </ul>
        <p>
          Met het indienen van uw KringloopWijzer verklaart u de ingevoerde gegevens zo goed en volledig mogelijk ingevuld te hebben. U kunt nog gegevens
          wijzigen, als u de status heropend naar concept. Dat kan alleen als de uiterste indiendatum van uw zuivelorganisatie niet is gepasseerd.
        </p>
        <b>Weet u zeker dat u deze KringloopWijzer wilt indienen?</b>
      </Spinal>
    </Modal>
  );

  return { indienenModal: component, isPending: indienen.isPending, openModal: () => setVisible(true) };
};
